module.exports = __webpack_public_path__ + "static/media/case-02-mobile.00b8ea23.png";